module.exports = __webpack_public_path__ + "client/img/header_img.df0bc754.png";